import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminEarlyAccessLeads = lazy(() => import("@/pages/admin/AdminEarlyAccessLeads"));

export const Route = createFileRoute("/admin/early-access-leads")({
  component: AdminEarlyAccessLeads,
});
